import React from "react";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import FeaturesServices from "../elements/service/FeaturesServices";
import Copyright from "../common/footer/Copyright";
import FooterTwo from "../common/footer/FooterTwo";

const FeaturesProduct = () => {
  return (
    <>
      <SEO
        title="We are a 360 degree software solution provider."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Digital Marketing and Web Development Services",
          provider: {
            "@type": "ProfessionalService",
            name: "WhatsOn Digital Agency",
            url: "https://bd.whatson.agency/",
            logo: "https://bd.whatson.agency/images/logo/WhatsOnAgencyWhite.png",
            sameAs: ["https://www.facebook.com/whatsondigitalagency"],
            telephone: "+8801601442162",
            address: {
              "@type": "PostalAddress",
              streetAddress: "H-9, 1F, R-2 S-3",
              addressLocality: "Dhaka",
              postalCode: "1230",
              addressCountry: "BD",
            },
          },
          areaServed: {
            "@type": "Place",
            name: "International",
          },
          description:
            "WhatsOn Digital Agency provides Development Web Design and Development, Web Application, eCommerce Solution, ERP Solutions, CRM Solutions, Email Marketing, Video Editing, Domain Register, Web Hosting, SEO, Facebook Ads, YouTube Advertisement, Google Advertisement and online growth solutions for businesses.",
          url: "https://bd.whatson.agency/services",
        }}
      />
      <Layout>
        {/* <BreadcrumbOne 
                    title="The Easiest Way To Create Website <br /> Quick Copy & Make site."
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Service"
                /> */}
        <div className="main-content">
          {/* Start Service Area  */}
          <div className="rn-service-area rn-section-gap">
            <div className="container">
              {/* <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "What we can do for you"
                                        title = "Services provide for you."
                                        description = "There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration."
                                     />
                                </div>
                            </div> */}
              <FeaturesServices
                serviceStyle="service__style--1 bg-color-blackest radius mt--25"
                textAlign="text-center"
              />
       

        {/* Start Copyrith Area  */}
       
            
            </div>
          </div>
        </div>
      
       
       
      </Layout>
       <FooterTwo />
         <Copyright/>
    </>
  );
};

export default FeaturesProduct;
